import React, { useState, useEffect, useCallback } from "react";
import { useSnackbar } from "notistack";
import DynamicTable from "../../components/DataTables/DynamicTable";
import SeguridadesLogic from "../../functions/logic/Seguridades";
import FormModal from "../../components/General/FormModal";
import Spiner from "../../components/General/Spiner";

const Usuarios = () => {
  const [spiner, setSpiner] = useState(false);
  const [isOpenModalform, setIsOpenModalForm] = useState(false);
  const [dataTableroForm, setDataTableroForm] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [saveType, setSaveType] = useState("I");
  const [header, setHeader] = useState("I");
  const [userId, setUsuarioId] = useState(0);
  const [data, setdata] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const getGroupUser = useCallback(
    async (page, perPage, search) => {
      setSpiner(true);
      const resp = await SeguridadesLogic.usuariosLogic(page, perPage, "I",search);
      if (resp.success) {
        const formatearUsuario = (usuario) => {
          return usuario.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
        };

        const dataFormateada = resp.data.map((usuarioObj) => ({
          ...usuarioObj,
          Usuarios: formatearUsuario(usuarioObj.Usuarios),
        }));

        setOriginalData(dataFormateada); // Guardamos los datos originales
        setdata(dataFormateada);
        setTotalRows(resp.totalRows);
      }

      enqueueSnackbar(resp.message, {
        variant: resp.variant,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setSpiner(false);
    },
    [enqueueSnackbar]
  );

  useEffect(() => {
    getGroupUser(1, 10,"");
  }, [getGroupUser]);

  const handlePageChange = (page, perPage) => {
    getGroupUser(page, perPage,"");
  };


//    const handleSearch = (item) => {
//    const textoBusqueda = item.toLowerCase();

//    const filtrado = originalData.filter((usuario) =>
//      usuario.Usuarios.toLowerCase().includes(textoBusqueda)
      // || usuario.Correo.toLowerCase().includes(textoBusqueda) // opcional
//    );

//    setdata(filtrado);
//  };

    const handleSearch = (item) => {

      getGroupUser(1, 10,item);
  };


  const columns = ["Usuarios", "Rol", "Estado"];

  const getColorForRol = (rol) => {
    switch (rol.toLowerCase()) {
      case "tableros":
        return "lightblue";
      case "seguridades":
        return "lightcoral";
      case "ventas":
        return "lightgreen";
      default:
        return "lightgray";
    }
  };

  const handleNew = async () => {
    cleanStorage();
    setSaveType("I");
    setUsuarioId(0);
    setSpiner(true);
    setDataTableroForm([]);
    setIsOpenModalForm(true);
    setSpiner(false);
    setHeader("Nuevo Usuario");
  };

  const cleanStorage = () => {
    localStorage.removeItem("code");
    localStorage.removeItem("name");
    localStorage.removeItem("description");
    localStorage.removeItem("fromValid");
    localStorage.removeItem("untilValid");
    localStorage.removeItem("price");
    localStorage.removeItem("discount");
    localStorage.removeItem("initialPercentage");
    localStorage.removeItem("status");
  };

  const handleCloseModal = () => {
    setIsOpenModalForm(false);
    cleanStorage();
  };

  const handledSave = async (event) => {};

  const handleEdit = async (item) => {
    setSpiner(true);
    const resp = await SeguridadesLogic.usuariosByIdLogic(item.id);
    cleanStorage();
    setSaveType("E");
    setUsuarioId(item.id);
    setSpiner(true);
    setDataTableroForm(resp);
    setIsOpenModalForm(true);
    setSpiner(false);
    setHeader("Usuario");
  };

  return (
    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        header={header}
        button={"Guardar"}
        formData={dataTableroForm}
        handledSave={handledSave}
        opt={"usuarios"}
        modalWith={"md"}
      />

      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Seguridades</li>
                <li className="breadcrumb-item">usuarios</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  <DynamicTable
                    columns={columns}
                    data={data.map((item) => ({
                      ...item,
                      Usuarios: (
                        <div>
                          <strong>{item.Usuarios}</strong>
                          <br />
                          <span style={{ fontSize: "smaller", color: "gray" }}>
                            {item.Correo}
                          </span>
                        </div>
                      ),
                      Rol: (
                        <div>
                          {item.Rol.map((rol, index) => (
                            <span
                              key={index}
                              style={{
                                backgroundColor: getColorForRol(rol),
                                padding: "5px",
                                borderRadius: "5px",
                                marginRight: "5px",
                                display: "inline-block",
                              }}
                            >
                              {rol}
                            </span>
                          ))}
                        </div>
                      ),
                    }))}
                    onNew={handleNew}
                    onEditPHX={handleEdit}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Usuarios;
